(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-salon-countdown"] && !Shopify.designMode) return;
  try {
    var lpSalonTimers = document.querySelectorAll('[data-lp-salon-countdown]:not([data-lp-managed])');
  if (lpSalonTimers.length) {
    var lpSalonKey = 'lp_salon_timer_start';
    var lpSalonDuration = 0;
    for (var i = 0; i < lpSalonTimers.length && !lpSalonDuration; i++) {
      var hAttr = parseInt(lpSalonTimers[i].getAttribute('data-hours'), 10);
      var mAttr = parseInt(lpSalonTimers[i].getAttribute('data-minutes'), 10);
      if (!isNaN(hAttr) || !isNaN(mAttr)) {
        lpSalonDuration = ((isNaN(hAttr) ? 0 : hAttr) * 3600 + (isNaN(mAttr) ? 0 : mAttr) * 60) * 1000;
      }
    }
    if (!lpSalonDuration) {
      lpSalonDuration = (5 * 3600 + 34 * 60) * 1000;
    }
    var lpSalonNow = Date.now();
    var lpSalonStart = NaN;
    try {
      lpSalonStart = parseInt(window.localStorage.getItem(lpSalonKey), 10);
    } catch (e) {}
    if (isNaN(lpSalonStart) || lpSalonStart > lpSalonNow) {
      lpSalonStart = lpSalonNow;
      try {
        window.localStorage.setItem(lpSalonKey, String(lpSalonStart));
      } catch (e) {}
    }
    var lpSalonPad = function (n) {
      return n < 10 ? '0' + n : String(n);
    };
    var lpSalonRender = function () {
      var elapsed = (Date.now() - lpSalonStart) % lpSalonDuration;
      var left = Math.ceil((lpSalonDuration - elapsed) / 1000);
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      for (var j = 0; j < lpSalonTimers.length; j++) {
        var el = lpSalonTimers[j];
        var hEl = el.querySelector('[data-unit="h"]');
        var mEl = el.querySelector('[data-unit="m"]');
        var sEl = el.querySelector('[data-unit="s"]');
        if (hEl) hEl.textContent = lpSalonPad(h);
        if (mEl) mEl.textContent = lpSalonPad(m);
        if (sEl) sEl.textContent = lpSalonPad(s);
      }
    };
    lpSalonRender();
    var lpSalonReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!lpSalonReduce) {
      window.setInterval(lpSalonRender, 1000);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-salon-media"] && !Shopify.designMode) return;
  try {
    var lpSalonVideos = document.querySelectorAll('video[data-lp-salon-video]');
  var lpSalonReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (lpSalonVideos.length && !lpSalonReduceMotion) {
    var lpSalonAttach = function (video) {
      if (video.getAttribute('data-lp-salon-ready')) return;
      var source = video.querySelector('source[data-src]');
      if (!source) return;
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
      video.setAttribute('data-lp-salon-ready', '1');
      video.muted = true;
      video.load();
    };
    var lpSalonPlay = function (video) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    };
    var lpSalonObserver = null;
    if ('IntersectionObserver' in window) {
      lpSalonObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              lpSalonAttach(video);
              lpSalonPlay(video);
            } else if (video.getAttribute('data-lp-salon-ready')) {
              video.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
    }
    var lpSalonWatch = function (video) {
      if (lpSalonObserver) {
        lpSalonObserver.observe(video);
      } else {
        lpSalonAttach(video);
        lpSalonPlay(video);
      }
    };
    Array.prototype.forEach.call(lpSalonVideos, function (video) {
      if (video.hasAttribute('data-lp-salon-after-load') && document.readyState !== 'complete') {
        window.addEventListener(
          'load',
          function () {
            lpSalonWatch(video);
          },
          { once: true }
        );
      } else {
        lpSalonWatch(video);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-salon-tokens"] && !Shopify.designMode) return;
  try {
    if (document.querySelector('.lp-salon')) {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        var el = target && target.closest ? target.closest('[data-lp-element]') : null;
        if (el && el.closest('.lp-salon')) {
          var text = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
          var url = el.href || el.getAttribute('href') || '';
          var main = el.closest('.lp-salon');
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'lp_click',
            lp_element: el.getAttribute('data-lp-element'),
            click_text: text,
            click_url: url,
            lp_page: main.getAttribute('data-lp-page') || 'salon-listicle'
          });
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
